import {
  EffectiveOperationPermissionsMap,
  OperationPermissionConfig,
} from '~teacher/hook/workspaces/permissionsV2/composePermissions/types';

import { WorkspaceRole } from '../../../../../../api/workspaces/getWorkspaceMembers';
import { mapFromArray } from '../utils/mapFromArray';
import { defaultNoPermission } from './defaultNoPermission';
import { determinePermissions } from './determinePermissions';

interface CreateComposePermission {
  isBetaUser: boolean;
  isPro: boolean;
  workspaceMemberType: WorkspaceRole;
}

/**
 * In order to make it easier to easier test and modify
 * we don't directly import the json config.
 *
 * If `isBetaUser`, `isPro` or `workspaceMemberType` are not suppled, it's
 * assumed that there are no permissions
 */
export function createComposePermission(
  permissionConfig: OperationPermissionConfig
) {
  return ({
    isBetaUser,
    isPro,
    workspaceMemberType,
  }: CreateComposePermission): EffectiveOperationPermissionsMap => {
    // Until we know all of these things, assume there are no permissions.
    const areAnyNull =
      isBetaUser === null ||
      isBetaUser === undefined ||
      isPro === undefined ||
      isPro === null ||
      workspaceMemberType === null ||
      workspaceMemberType === undefined;

    const permissions = areAnyNull
      ? defaultNoPermission(permissionConfig)
      : determinePermissions({
          permissionConfig: permissionConfig,
          isBetaUser: isBetaUser,
          isPro: isPro,
          workspaceMemberType: workspaceMemberType,
        });

    return mapFromArray(permissions);
  };
}
